var path = 'components/number-input.tpl.html';
var html = " <md-input-container class=\"md-block tk-number-input\"> <label translate>{{ titleText }}</label> <input ng-disabled=disabled placeholder=\"{{ placeholderText() | translate }}\" type=number step={{step}} ng-model=numVal ng-blur=numberInputChanged()> </md-input-container> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/number-input.tpl.html
// module id = 1045
// module chunks = 1